<div class="page-layout carded fullwidth inner-scroll">
    <!-- TOP BACKGROUND -->
    <div class="top-bg accent"></div>
    <!-- / TOP BACKGROUND -->

    <!-- CENTER -->
    <div class="center">
        <!-- HEADER -->
        <div class="header accent">
            <!-- APP TITLE -->
            <div class="logo mb-24 mb-sm-0">
                <mat-icon class="logo-icon s-32 mr-16">
                    {{ icon }}
                </mat-icon>
                <span class="logo-text h1">{{
                        title
                    }}</span>
            </div>
            <!-- / APP TITLE -->
        </div>
        <!-- / HEADER -->

        <!-- CONTENT -->
        <div class="content-card">
            @switch (pageStatus) {
                @case ("loading") {
                    <div class="loader">
                        <mat-spinner></mat-spinner>
                    </div>
                }
                @case ("loadError") {
                    <div class="error">
                        <admin-error [error]="pageError"></admin-error>
                    </div>
                }
                @default {
                    <ng-content></ng-content>
                }
            }
        </div>
        <!-- / CONTENT -->
    </div>
    <!-- /CENTER -->
</div>
